'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { cn } from 'cn';
import { AnimatePresence, motion, useReducedMotion } from 'motion/react';
interface RotatingWordProps {
  words: readonly [string, ...string[]];
  className?: string;
  /** Seconds before the first word rolls in. */
  delay?: number;
  /** Time each word holds before the next rolls in. */
  intervalMs: number;
}

/**
 * Rolls through `words` once like a slot machine, each word
 * dropping out upward as the next rises in, then holds the
 * last. Shows the first word, still, under reduced motion.
 */
export function RotatingWord(t0) {
  const $ = _c(25);
  const {
    words,
    className,
    delay: t1,
    intervalMs
  } = t0;
  const delay = t1 === undefined ? 0 : t1;
  const reduceMotion = useReducedMotion();
  const [index, setIndex] = useState(0);
  let t2;
  let t3;
  if ($[0] !== index || $[1] !== intervalMs || $[2] !== reduceMotion || $[3] !== words.length) {
    t2 = () => {
      if (reduceMotion || index >= words.length - 1) {
        return;
      }
      const id = setTimeout(() => setIndex(index + 1), intervalMs);
      return () => clearTimeout(id);
    };
    t3 = [index, words.length, intervalMs, reduceMotion];
    $[0] = index;
    $[1] = intervalMs;
    $[2] = reduceMotion;
    $[3] = words.length;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  if (reduceMotion) {
    let t4;
    if ($[6] !== className) {
      t4 = cn("block", className);
      $[6] = className;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    let t5;
    if ($[8] !== t4 || $[9] !== words[0]) {
      t5 = <span className={t4}>{words[0]}</span>;
      $[8] = t4;
      $[9] = words[0];
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    return t5;
  }
  let t4;
  if ($[11] !== className) {
    t4 = cn("relative block overflow-hidden pb-[0.15em]", className);
    $[11] = className;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  let t6;
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      y: "110%",
      opacity: 0,
      filter: "blur(8px)"
    };
    t6 = {
      y: 0,
      opacity: 1,
      filter: "blur(0px)"
    };
    t7 = {
      y: "-110%",
      opacity: 0,
      filter: "blur(8px)"
    };
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t5 = $[13];
    t6 = $[14];
    t7 = $[15];
  }
  const t8 = index === 0 ? delay : 0;
  let t9;
  if ($[16] !== t8) {
    t9 = {
      type: "spring",
      stiffness: 240,
      damping: 24,
      delay: t8
    };
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  const t10 = words[index] ?? words[0];
  let t11;
  if ($[18] !== index || $[19] !== t10 || $[20] !== t9) {
    t11 = <AnimatePresence mode="popLayout" data-sentry-element="AnimatePresence" data-sentry-source-file="rotating-word.tsx"><motion.span key={index} className="inline-block" initial={t5} animate={t6} exit={t7} transition={t9} data-sentry-element="motion.span" data-sentry-source-file="rotating-word.tsx">{t10}</motion.span></AnimatePresence>;
    $[18] = index;
    $[19] = t10;
    $[20] = t9;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t11 || $[23] !== t4) {
    t12 = <span className={t4} data-sentry-component="RotatingWord" data-sentry-source-file="rotating-word.tsx">{t11}</span>;
    $[22] = t11;
    $[23] = t4;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  return t12;
}